import { FontWeights, getTheme, mergeStyleSets } from "@fluentui/react";
const theme = getTheme();
export const contentStyles = mergeStyleSets({
    container: {
      display: "flex",
      width: "70%",
      flexFlow: "column nowrap",
      alignItems: "stretch",
      margin: "15px",
    },
    header: [
      theme.fonts.xLargePlus,
      {
        flex: "1 1 auto",
        borderTop: `4px solid ${theme.palette.themePrimary}`,
        color: theme.palette.neutralPrimary,
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "12px 12px 14px 24px",
      },
    ],
    heading: {
      display: "flex",
      justifyContect: "center",
      alignItems: "center",
      color: theme.palette.neutralPrimary,
      fontWeight: FontWeights.semibold,
      fontSize: "inherit",
      margin: "0",
    },
    body: {
      flex: "4 4 auto",
      padding: "0 24px 24px 24px",
      overflowY: "hidden",
      selectors: {
        p: { margin: "14px 0" },
        "p:first-child": { marginTop: 0 },
        "p:last-child": { marginBottom: 0 },
      },
    },
  });
  export const iconButtonStyles = {
    root: {
      color: theme.palette.neutralPrimary,
      marginLeft: "auto",
      marginTop: "4px",
      marginRight: "2px",
    },
    rootHovered: {
      color: theme.palette.neutralDark,
    },
  };
export const CardStyles = {
  layout: {
    margin: 5,
    padding: 0,
  },
};

